import { Star } from "lucide-react";
import { TESTIMONIALS } from "../data/content";

export const Testimonials = () => {
  return (
    <section id="testimonials" className="py-20 lg:py-28 bg-[#F5F0EA] grain-bg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="text-xs font-semibold uppercase tracking-[0.25em] text-olive">Loved & Trusted</span>
          <h2 className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl text-ink tracking-tight">
            Tastes like real sugar. Zero the spike.
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="bg-white rounded-3xl p-7 border border-[#EFE9E0] flex flex-col"
            >
              <div className="flex gap-1">
                {[...Array(t.rating)].map((_, s) => (
                  <Star key={`${t.name}-star-${s}`} size={16} className="fill-terracotta text-terracotta" />
                ))}
              </div>
              <blockquote className="mt-4 text-[#524B46] leading-relaxed flex-1">"{t.quote}"</blockquote>
              <figcaption className="mt-6 flex items-center gap-3 pt-5 border-t border-[#EFE9E0]">
                <img src={t.avatar} alt={t.name} className="w-11 h-11 rounded-full object-cover" loading="lazy" />
                <div>
                  <p className="font-semibold text-ink text-sm">{t.name}</p>
                  <p className="text-xs text-olive font-medium">{t.tag}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
